// Text shrinks in these steps until it fits its box, down to this fraction of the chosen size.
export const FIT_STEP = 0.05;
export const MIN_FIT = 0.4;

// True when any element sticks out of `box` (its offsetParent).
// offset* ignore ancestor transforms (rotated previews); an element's own scale() transform is applied by hand.
export function textOverflows(box, elements) {
    return elements.some((el) => {
        if (!el) return false;
        const transform = getComputedStyle(el).transform;
        const scale = transform === 'none' ? 1 : parseFloat(transform.split('(')[1]);
        const top = el.offsetTop + (el.offsetHeight * (1 - scale)) / 2;
        const left = el.offsetLeft + (el.offsetWidth * (1 - scale)) / 2;
        return (
            top < -1 ||
            top + el.offsetHeight * scale > box.clientHeight + 1 ||
            left < -1 ||
            left + el.offsetWidth * scale > box.clientWidth + 1 ||
            el.scrollWidth > el.clientWidth + 1
        );
    });
}
